import { cn } from "@babybjorn/ui";
import { useState, type FC } from "react";
import * as s from "./VideoPlayer.module.scss";

type VideoPlayerProps = {
	videoUrl: string | undefined;
};

const VideoPlayer: FC<VideoPlayerProps> = ({ videoUrl }) => {
	const [loaded, setLoaded] = useState(false);

	return (
		<video
			className={cn(s.videoPlayer, { [s.loaded]: loaded })}
			width="100%"
			height="100%"
			preload="auto"
			muted
			autoPlay
			loop
			playsInline
			onCanPlay={() => {
				setTimeout(() => {
					setLoaded(true);
				}, 0);
			}}
		>
			<source src={videoUrl} />
		</video>
	);
};
export default VideoPlayer;
